import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { HttpHeaderService } from 'src/app/shared/service/http-header.service';
import { SearchService } from 'src/app/shared/service/search/search.service';
import { AutoSearchConditionGroup } from 'src/app/shared/model/auto-search-condition-group.model';

@Injectable({
  providedIn: 'root'
})
export class SearchAutoService extends SearchService {
  // サービス毎に初期値を設定する
  initPage = { page: 1 };
  initPerPage = { perPage: 50 };
  selfServiceName = 'SearchAutoService';

  constructor(header: HttpHeaderService, http: HttpClient) {
    super(header, http);
  }

  public doSearch(id?: string, params?: object): Observable<any> {
    return super.requestPost(
      'api/v1/matching_auto_with_filter',
      this.getSearchParameters(params)
    );
  }

  public setSearchCondition(searchCondition): void {
    localStorage.setItem(
      'searchCondition' + this.selfServiceName,
      JSON.stringify(searchCondition)
    );
  }
  public getAutoSearchConditionGroup(): AutoSearchConditionGroup {
    return JSON.parse(
      localStorage.getItem('searchCondition' + this.selfServiceName)
    );
  }

  getSearchParameters(sortParams?: object) {
    const condition =
      this.getAutoSearchConditionGroup() || new AutoSearchConditionGroup({});
    const count = this.getSearchCount().getParams();
    const page = this.getSearchPage().getParams();
    const searchTags = { search_tag_ids: this.getSearchTagIds() };
    return Object.assign(condition, count, page, searchTags, sortParams);
  }
}
